/**
 * 模块名称: 转岗管理详情页
 * @author zhuyan@372163.com
 */

import React, { useState, useEffect } from 'react'
import {
  Descriptions,
  Steps,
  Button,
  Modal,
  Input,
  Table,
  Icon,
  message,
  Spin
} from 'antd'
import api from '@/api'
import { parseSearch, debounce, judgeCryptoParamsUrl } from '@/utils'

const DItem = Descriptions.Item
const { Step } = Steps;
const { Column } = Table

const JobTransferDetail = (props) => {
  const { location, history } = props
  const search = parseSearch(location.search)
  const [detailData, setDetailData] = useState({})
  const [detailDataTwo, setDetailDataTwo] = useState({})
  const [oldDetailDataTwo, setOldDetailDataTwo] = useState({})
  const [oldDetailData, setOldDetailData] = useState({}) //原来数据
  const [detailDataId, setdetailDataId] = useState('')
  const [statusList, setStatusList] = useState([])
  const [logConList, setLogConList] = useState([])
  const [buttonAuthList, setButtonAuthList] = useState([])
  const [passModalVisible, setModalVisible] = useState(false) //确认弹框
  const [turnModalVisible, setTurnModalVisible] = useState(false) //驳回弹框
  const [textAreaVal, setTextAreaVal] = useState('') //判断框是否为空
  const [textDisplay, setTextDisplay] = useState(true) //是否提示必选
  const [pasDesc, setPasDesc] = useState('')  //通过意见
  const [showFile, setShowFile] = useState([]) //附件
  const [oldshowFile, setoldFile] = useState([]) //更新前附件
  const [detailLoading, setDetailLoading] = useState(true)

  useEffect(() => {
    if (judgeCryptoParamsUrl(search)) {
      api.getStaffTransferInfo({ id: search.id }).then(data => {
        if (search.msgId) {
          api.setMessageReaded({ ids: [search.msgId] })
        }
        setDetailData(data)
        setDetailDataTwo(data.staffInfo)
        setOldDetailDataTwo(data.oldData && data.oldData.staffInfo ? data.oldData.staffInfo : data.staffInfo)
        setOldDetailData(data.oldData ? data.oldData : data) //更新前数据
        setdetailDataId(data.id)
        setStatusList(data.procedureStatusList) // 审批记录
        setLogConList(data.logList) // 审批日志
        setButtonAuthList(data.buttonAuthList) // 审批权限
        setShowFile(data.attachmentCn) //附件
        setoldFile(data.oldData && data.oldData.attachmentCn ? data.oldData.attachmentCn : data.attachmentCn)
        // if(data.oldData && data.oldData.attachmentCn) setoldFile(data.oldData.attachmentCn)
        setDetailLoading(false)
      })
    } else {
      message.error('没有本页访问权限')
      setTimeout(() => {
        history.go(-2)
      }, 1000)
    }
  }, [])

  // 通过
  const onBtnPassShow = () => {
    setModalVisible(true)
  }

  const onPassCancel = () => {
    setModalVisible(false)
  }

  const onPassDescChange = (e) => {
    setPasDesc(e.target.value)
  }

  const onApprove = () => {
    api.setStaffTransferPass({
      id: detailDataId,
      remark: pasDesc
    }).then(data => {
      api.getStaffTransferInfo({ id: search.id }, true).then(data => {
        setDetailData(data)
        setDetailDataTwo(data.staffInfo)
        setOldDetailDataTwo(data.oldData && data.oldData.staffInfo ? data.oldData.staffInfo : data.staffInfo)
        setOldDetailData(data.oldData ? data.oldData : data) //更新前数据
        setdetailDataId(data.id)
        setStatusList(data.procedureStatusList) // 审批记录
        setLogConList(data.logList) // 审批日志
        setButtonAuthList(data.buttonAuthList) // 审批权限
        setShowFile(data.attachmentCn) //附件
        setoldFile(data.oldData && data.oldData.attachmentCn ? data.oldData.attachmentCn : data.attachmentCn)
        // if(data.oldData && data.oldData.attachmentCn) setoldFile(data.oldData.attachmentCn)
      }) //确认通过后
    })
    setModalVisible(false)
  }

  // 驳回
  const onBtnTurnShow = () => {
    setTurnModalVisible(true)
    setTextDisplay(true)
  }

  const onTurnCancel = () => {
    setTurnModalVisible(false)
  }

  const onTurnApprove = () => {
    if (buttonAuthList.reject_msg_require) {
      if (textAreaVal.trim() === '') {
        setTextDisplay(false)
        return
      }
    }
    api.setStaffTransferReject({
      id: detailDataId,
      remark: textAreaVal
    }).then(data => {
      api.getStaffTransferInfo({ id: search.id }, true).then(data => {
        setDetailData(data)
        setDetailDataTwo(data.staffInfo)
        setOldDetailDataTwo(data.oldData && data.oldData.staffInfo ? data.oldData.staffInfo : data.staffInfo)
        setOldDetailData(data.oldData ? data.oldData : data) //更新前数据
        setdetailDataId(data.id)
        setStatusList(data.procedureStatusList) // 审批记录
        setLogConList(data.logList) // 审批日志
        setButtonAuthList(data.buttonAuthList) // 审批权限
        setShowFile(data.attachmentCn) //附件
        if (data.oldData && data.oldData.attachmentCn) setoldFile(data.oldData.attachmentCn)
      }) //确认驳回后
    })
    setTurnModalVisible(false)
  }

  const onDescChange = (e) => {
    setTextAreaVal(e.target.value)
    setTextDisplay(true)
  }

  // 驳回样式
  const turnNode = () => {
    return <>
      确认驳回 <Icon type="close-circle" theme="twoTone" twoToneColor="#DC143C" />
    </>
  }

  // 同意样式
  const agreeNode = () => {
    return <>
      确认通过 <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
    </>
  }

  // 转上级
  const onTurnUp = () => {
    api.setStaffTransferTurn({
      id: detailDataId,
      remark: ''
    }).then(data => {
      history.push('/hr/jobTransfer')
    }).catch()
  }

  // 补充资料
  const onReplenish = () => {
    api.setStaffTransferReplenish({
      id: detailDataId,
      remark: ''
    }).then(data => {
      history.push('/hr/jobTransfer')
    }).catch()
  }

  return (
    <Spin spinning={detailLoading}>
      <>
        <div className="pro-detail">
          <Descriptions title="转岗申请" layout="horizontal " className="pro-detail-title">
            <DItem label="申请人">{detailData.staffName}</DItem>
          </Descriptions>
          <Descriptions title="转岗申请流程" className="pro-detail-smailtitle"></Descriptions>
          <div className="promotionProcess" >
            <Steps>
              {
                statusList.map((item, index) => {
                  let status = 'wait'
                  if (item.time && item.time.length > 1) {
                    status = 'process'
                  }
                  return <Step status={status}
                    key={index}
                    value={item.time}
                    title={item.nodeName}
                    description={
                      <>
                        {item.persons && <div title={`${item.persons.map((item) => item)}`}>{`${item.persons.map((item) => item)}`}</div>}
                        <div title={item.statusName}>{item.statusName}</div>
                        <div title={item.time}>{item.time}</div>
                      </>
                      // `${item.persons.map((item)=>item)} ${item.statusName} ${item.time}`
                    }
                  />
                })
              }
            </Steps>
          </div>
          <div className="line-box"></div>
          <Descriptions title="申请信息"
            layout="vertical"
            className="pro-detail-smailtitle pro-apply"
          >
            <DItem label="姓名">
              <>
                {detailData.staffName}
                {oldDetailData.staffName !== detailData.staffName ? <div className="change-text">变更前：{oldDetailData.staffName}</div> : null}
              </>
              {/* { ()=>{
              if (oldDetailData.applyStaffName && oldDetailData.applyStaffName !== detailData.applyStaffName){
                return <div>变更前：{oldDetailData.applyStaffName}</div>
              }
            }} */}
            </DItem>

            <DItem label="原所属公司">
              <>
                {detailData.oldCompanyName}
                {oldDetailData.oldCompanyName !== detailData.oldCompanyName ? <div className="change-text">变更前：{oldDetailData.oldCompanyName}</div> : null}
              </>
            </DItem>
            <DItem label="原所属部门">
              <>
                {detailData.oldDepartmentName}
                {oldDetailData.oldDepartmentName !== detailData.oldDepartmentName ? <div className="change-text">变更前：{oldDetailData.oldDepartmentName}</div> : null}
              </>
            </DItem>
            <DItem label="原职级">
              <>
                {detailData.oldJobPositionCn}
                {oldDetailData.oldJobPositionCn !== detailData.oldJobPositionCn ? <div className="change-text">变更前：{oldDetailData.oldJobPositionCn}</div> : null}
              </>
            </DItem>
            <DItem label="原岗位级别">
              <>
                {detailData.oldJobStationCn ? detailData.oldJobStationCn : '--'}
                {oldDetailData.oldJobStationCn !== detailData.oldJobStationCn ? <div className="change-text">变更前：{oldDetailData.oldJobStationCn}</div> : null}
              </>
            </DItem>
            <DItem label="原直接主管">
              <>
                {detailData.oldLeaderName}
                {oldDetailData.oldLeaderName !== detailData.oldLeaderName ? <div className="change-text">变更前：{oldDetailData.oldLeaderName}</div> : null}
              </>
            </DItem>
            <DItem label="员工编号">
              <>
                {detailDataTwo.staffNo}
                {oldDetailDataTwo.staffNo !== detailDataTwo.staffNo ? <div className="change-text">变更前：{oldDetailDataTwo.staffNo}</div> : null}
              </>
            </DItem>
            <DItem label="毕业院校">
              {detailDataTwo.schoolName}
            </DItem>
            <DItem label="所学专业">
              {detailDataTwo.majorName}
            </DItem>
            <DItem label="入职日期">
              {detailDataTwo.entryDate}
            </DItem>
            <DItem label="工作年限（月）" span={2}>
              {detailDataTwo.entryMonthNum}
            </DItem>
            <DItem label="转入部门">
              <>
                {detailData.newDepartmentName}
                {oldDetailData.newDepartmentName !== detailData.newDepartmentName ? <div className="change-text">变更前：{oldDetailData.newDepartmentName}</div> : null}
              </>
            </DItem>
            <DItem label="转入公司">
              <>
                {detailData.newCompanyName}
                {oldDetailData.newCompanyName !== detailData.newCompanyName ? <div className="change-text">变更前：{oldDetailData.newCompanyName}</div> : null}
              </>
            </DItem>
            <DItem label="转入后直接主管">
              <>
                {detailData.managerStaffName}
                {oldDetailData.managerStaffName !== detailData.managerStaffName ? <div className="change-text">变更前：{oldDetailData.managerStaffName}</div> : null}
              </>
            </DItem>
            <DItem label="附件" span={3}>
              <>
                {
                  showFile && showFile.length >= 1 ? showFile.map((item, i) => {
                    return <div key={i}><a href={item.url} target="_blank" rel="noopener noreferrer">{item.name}</a></div>
                  }) : '无'
                }
                {JSON.stringify(showFile) && JSON.stringify(showFile) !== JSON.stringify(oldshowFile) ? <div className="change-text">变更前：
              {
                    oldshowFile && oldshowFile.length >= 1 ? oldshowFile.map((item, i) => {
                      return <div key={i}><a href={item.url} target="_blank" rel="noopener noreferrer">{item.name}</a></div>
                    }) : '无'
                  }</div> : null}
              </>
            </DItem>
            <DItem label="备注">
              <>
                {detailData.remark ? detailData.remark : '无'}
                {oldDetailData.remark !== detailData.remark ? <div className="change-text">变更前：{oldDetailData.remark}</div> : null}
              </>
            </DItem>
          </Descriptions>
          <div className="line-box"></div>
          <Descriptions
            title="审批记录"
            layout="horizontal"
            className="pro-detail-smailtitle"
          >
          </Descriptions>
          <Table
            dataSource={logConList}
            rowKey="nodeName"
            pagination={false}
          >
            <Column title="姓名" dataIndex="userInfo.staffName" />
            <Column title="时间" dataIndex="addTime" />
            <Column title="状态" dataIndex="status" />
            <Column title="审批意见" dataIndex="chargeMsg" />
          </Table>
          <div className="btn-setting">
            <Button hidden={!buttonAuthList.replenish} onClick={debounce(() => { onReplenish() }, 3000)}>补充资料</Button>
            <Button hidden={!buttonAuthList.return_up} onClick={debounce(() => { onTurnUp() }, 3000)}>转上级</Button>
            <Button hidden={!buttonAuthList.hasChargerPower} onClick={onBtnTurnShow}>驳回</Button>
            <Modal
              // title="确认驳回"
              title={turnNode()}
              visible={turnModalVisible}
              onOk={debounce(() => {onTurnApprove()}, 3000)}
              onCancel={onTurnCancel}
              footer={[
                <Button key="back" onClick={onTurnCancel}>取消</Button>,
                <Button key="submit" type="primary" onClick={debounce(() => {onTurnApprove()}, 3000)}>确定</Button>
              ]}
            >
              <div>
                <span>审批意见:</span>
                <Input.TextArea placeholder="请输入驳回审批意见" value={textAreaVal} onChange={onDescChange} maxLength={100} />
              </div>
              <span className="poine-text" hidden={textDisplay}>请填写审批意见</span>
            </Modal>
            <Button hidden={!buttonAuthList.hasChargerPower} type="primary" onClick={onBtnPassShow}>通过</Button>
            <Modal
              // title="确认通过"
              title={agreeNode()}
              visible={passModalVisible}
              onOk={debounce(() => {onApprove()}, 3000)}
              onCancel={onPassCancel}
              footer={[
                <Button key="back" onClick={onPassCancel}>取消</Button>,
                <Button key="submit" type="primary" onClick={debounce(() => {onApprove()}, 3000)}>确定</Button>
              ]}
            >
              <div>
                <span>审批意见:</span>
                <Input.TextArea placeholder="请输入通过审批意见" value={pasDesc} onChange={onPassDescChange} maxLength={100} />
              </div>
            </Modal>
          </div>
        </div>
      </>
    </Spin>
  )
}

export default JobTransferDetail